import { LinkTargetType } from "views/services/playground";
import { TProductElement } from "../../views/services/product";

export function runInBrowser() {
	return !!window;
}
/**
 * 某一模块是否在可视窗口内
 */
export const isInWindowView = (ele: HTMLElement, fixedTop: number = 0): boolean => {
	if (!runInBrowser()) {
		return false;
	}
	if (ele && ele.getBoundingClientRect()) {
		const { top, bottom } = ele.getBoundingClientRect();
		const windowHeight = window.innerHeight;
		if (bottom <= fixedTop) {
			return false;
		}
		if (top >= windowHeight - fixedTop) {
			return false;
		}
		return true;
	}
	return false;
};

/**
 * a 跳转方式
 * App 内利用特性href
 * web 上利用特性onClick
 */
interface TransformAParamProps {
	isInApp: boolean;
	aTarget: LinkTargetType;
	link: string;
	onClick?: () => void;
}
interface TransformAParamResp {
	href?: string;
	target?: string;
	"data-href"?: string;
	onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}
export const transformAParam = ({
	isInApp = true,
	aTarget = LinkTargetType.Blank,
	link = "",
	onClick,
}: TransformAParamProps): TransformAParamResp => {
	if (!link) {
		return {};
	}

	if (link.startsWith("#")) {
		return {
			href: link,
			target: LinkTargetType.Self,
		};
	}

	if (isInApp || aTarget === LinkTargetType.Self) {
		return {
			href: link,
			target: aTarget,
		};
	}
	return {
		onClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
			e.preventDefault();
			e.stopPropagation();
			onClick && onClick();
			window.open(link);
		},
		"data-href": link,
	};
};

export const returnProductIndex = (gpid: string, product: TProductElement[]): number => {
	let index = -1;
	if (gpid && product) {
		const ind = product.findIndex((item) => item.gpid === gpid);
		if (ind > -1) {
			index = ind + 1;
		}
	}
	return index;
};
